import { Logger } from '@mantou/gem/helper/logger';

export const logger = new Logger('DEBUG');
